import { createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/@reduxjs/useInjectReducer";
import { useInjectSaga } from "utils/@reduxjs/useInjectSaga";
import { logoutSaga } from "./saga";

export const initialState = {
  authData: {
    user: null,
    token: null,
    loading: false,
    error: null
  }
};

export const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    // Logout
    logoutRequest: (state) => {
      state.authData.loading = true;
    },
    logoutSuccess: (state) => {
      state.authData = {
        user: null,
        token: null,
        loading: false,
        error: null
      };
    },
    logoutError: (state, action) => {
      state.authData.loading = false;
      state.authData.error = action.payload;
    }
  }
});

export const useLoginSlice = () => {
  useInjectReducer(LoginSlice.name, LoginSlice.reducer);
  useInjectSaga(LoginSlice.name, logoutSaga);
  return { actions: LoginSlice.actions };
};

export const { actions: LoginActions } = LoginSlice;

export default LoginSlice.reducer;
